import { useCallback } from 'react';

import { useInstantSearch } from 'react-instantsearch';

import { useFilterByNearYou } from './hooks/useFilterByNearYou';
import { useFilterByTrending } from './hooks/useFilterByTrending';
import { useFilterByVictories } from './hooks/useFilterByVictories';

type Result = ModelHookResult<
	{ isNearYouLoading: boolean },
	{
		filterByVictories: () => void;
		filterByNearYou: () => void;
		filterByTrending: () => void;
	}
>;

export function useExploreButtons(): Result {
	const {
		actions: { filterByVictories },
	} = useFilterByVictories();

	const {
		data: { isNearYouLoading },
		actions: { filterByNearYou },
	} = useFilterByNearYou();

	const {
		actions: { filterByTrending },
	} = useFilterByTrending();

	const { status } = useInstantSearch();

	return {
		data: { isNearYouLoading },
		actions: {
			filterByVictories: useCallback(() => {
				if (status === 'loading') {
					return;
				}
				filterByVictories();
			}, [filterByVictories, status]),
			filterByNearYou: useCallback(() => {
				if (status === 'loading') {
					return;
				}
				filterByNearYou();
			}, [filterByNearYou, status]),
			filterByTrending: useCallback(() => {
				if (status === 'loading') {
					return;
				}
				filterByTrending();
			}, [status, filterByTrending]),
		},
	};
}
